export default __webpack_public_path__ + "static/team2-ac468f4870ede1147cb38c958db60853.jpg";